import { takeEvery } from 'redux-saga/effects';

import sagaShiftSendReview, { action as sagaShiftSendReviewAction } from './sagaShiftSendReview';

export default () => {
  return function* () {
    yield takeEvery(sagaShiftSendReviewAction, sagaShiftSendReview);
  };
};
